<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_MS = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Nicht reaktiv: Timer und Suchzähler je Komponenteninstanz
    this.timer = null;
    this.searchId = 0;
    this.destroyed = false;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.stopSearch();
  },

  watch: {
    search(val) {
      if (!val) {
        this.stopSearch();
        this.items = this.select && typeof this.select === "object" ? [this.select] : [];
        return;
      }

      if (val === this.select || (this.select && this.select.text === val)) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    stopSearch() {
      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.searchId++;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopSearch();

      const searchId = this.searchId;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoderReady.then(geocoder => {
          if (searchId !== this.searchId || this.destroyed) {
            return null;
          }

          return geocoder.autocomplete(value);
        }).then(items => {
          if (searchId !== this.searchId || this.destroyed || items === null) {
            return;
          }

          this.items = items;
        }).catch(() => {
          if (searchId === this.searchId && !this.destroyed) {
            this.items = [];
          }
        }).then(() => {
          if (searchId === this.searchId && !this.destroyed) {
            this.loading = false;
          }
        });
      }, DEBOUNCE_MS);
    },

    change(o) {
      this.stopSearch();
      this.items = o && typeof o === "object" ? [o] : [];
      this.$emit("change", o);
    }
  }
};
</script>
